 /*
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 * All rights reserved.
 *
 * This source code is licensed under the license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @flow
 */

import {AbstractCrudObject} from './../abstract-crud-object';

/**
 * AdAccountCampaignAttributionOptionInfo
 * @extends AbstractCrudObject
 * @see {@link https://developers.facebook.com/docs/marketing-api/}
 */
export default class AdAccountCampaignAttributionOptionInfo extends AbstractCrudObject {
  static get Fields (): Object {
    return Object.freeze({
      is_eligible: 'is_eligible',
      value: 'value',
    });
  }

}
